import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-400 py-16 border-t border-gray-800/50 relative z-20">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/1593c15ad88356866a2eabcebc8aef2c67d9fc5afee8d56439ced245a0c6c3417efffbd95aedd1b6f68107af9f17a1fd/images/aW1hZ2UvcG5n/7cf330b2fb2aaf6b54c2cba38f69981f.png" 
                alt="LAJ Digital Logo" 
                className="h-10 w-auto object-contain hover:opacity-90 transition-opacity duration-300"
              />
            </Link>
            <p className="text-gray-400 mb-6 max-w-md font-light text-base">
              Strategy, technology, and marketing working together in a unified ecosystem.
            </p>
            <p className="text-sm text-gray-500 tracking-widest uppercase font-display">
              Founded by the teams behind<br/> Sommers Marketing Group & Dapper Dev LLC.
            </p>
          </div>

          <div>
            <h4 className="text-white font-display font-bold mb-6 tracking-wide uppercase text-base">Navigation</h4>
            <ul className="space-y-3 text-base font-light">
              <li><Link to="/" state={{ scrollTo: 'services' }} className="hover:text-cyan-400 transition-colors">Services</Link></li>
              <li><Link to="/" state={{ scrollTo: 'why-us' }} className="hover:text-cyan-400 transition-colors">About</Link></li>
              <li><Link to="/" state={{ scrollTo: 'team' }} className="hover:text-cyan-400 transition-colors">Our Team</Link></li>
              <li><Link to="/" state={{ scrollTo: 'contact' }} className="hover:text-cyan-400 transition-colors">Contact</Link></li>
              <li><a href="https://afterhourscallbot.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">After Hours CallBot</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-display font-bold mb-6 tracking-wide uppercase text-base">Network</h4>
            <ul className="space-y-3 text-base font-light">
              <li><a href="https://sommersmarketinggroup.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-400 transition-colors">SommersMarketingGroup.com</a></li>
              <li><a href="https://dapperdev.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-400 transition-colors">DapperDev.com</a></li>
              <li><a href="https://afterhourscallbot.com" target="_blank" rel="noopener noreferrer" className="hover:text-purple-400 transition-colors">AfterHoursCallBot.com</a></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-gray-800/50 flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-light text-gray-500 tracking-wide">
          <p>© {new Date().getFullYear()} LAJ Digital. All rights reserved.</p>
          <div className="flex gap-6 flex-wrap justify-center">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/sms-optin" className="hover:text-white transition-colors">SMS Opt-In</Link>
            <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;